import React from "react";

const CampaignPrizesList = React.lazy(() => import('src/pages/campaign_prizes/CampaignPrizesList'));
const AddCampaignPrizes = React.lazy(() => import('src/pages/campaign_prizes/AddCampaignPrizes'));
const EditCampaignPrizes = React.lazy(() => import('src/pages/campaign_prizes/EditCampaignPrizes'));

const routes = [
    { path: '/dashboard/campaign-prizes-list/add', name: 'Add', element: AddCampaignPrizes },
    { path: '/dashboard/campaign-prizes-list/edit', name: 'Edit', element: EditCampaignPrizes },
    { path: '/dashboard/campaign-prizes-list', name: 'Campaign Prizes', element: CampaignPrizesList },
];

export default routes;